import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HTTPCONSTANTS } from '../http/http-constants';

/**
 * DEV-ONLY client for the PlatexAPI dev compare endpoints
 * (api/dev/compare/*). These endpoints return 404 unless the API is running in
 * its Development environment, and the live_v2 side is additionally gated by the
 * API's FeatureFlags:UseLiveV2. This service is consumed only by the dev-only
 * /dev/live-v2-compare route and never by production rendering paths.
 */

export interface PlateSeoMeta {
  canonicalSlug: string;
  canonicalUrl: string;
  isIndexable: boolean;
  noindexReason: string;
  metaTitle: string;
  metaDescription: string;
  h1: string;
  structuredData: string;
}

export interface LiveV2Seller {
  siteName: string;
  sourceType: string;
  purchaseUrl: string;
  totalPriceMinor: number;
  isCheapest: boolean;
  lastCheckedAt: string;
  lastSeenAt: string;
}

export interface PlateDetailLike {
  owner: number;
  formattedRegistration: string;
  registrationString: string;
  style: string;
  issueMonth: string;
  issueYear: string;
  issueRegion: string;
  platexPrice: number;
  plateCategory: string;
}

export interface LiveV2PlateView {
  found: boolean;
  detail: PlateDetailLike;
  isAvailable: boolean;
  bestPriceMinor: number | null;
  dvlaPriceMinor: number | null;
  activeListingCount: number;
  bestSourceType: string;
  sellers: LiveV2Seller[];
  seo: PlateSeoMeta;
}

export interface PlateCompareResult {
  registration: string;
  useLiveV2Enabled: boolean;
  legacy: PlateDetailLike;
  liveV2: LiveV2PlateView;
  parityNotes: string[];
}

@Injectable({ providedIn: 'root' })
export class LiveV2CompareService {
  constructor(private http: HttpClient) {}

  public compare(registration: string): Observable<PlateCompareResult> {
    return this.http.get<PlateCompareResult>(
      `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.apiBaseAddress}/dev/compare/${registration}`
    );
  }

  public getSeo(registration: string): Observable<PlateSeoMeta> {
    return this.http.get<PlateSeoMeta>(
      `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.apiBaseAddress}/dev/compare/${registration}/seo`
    );
  }
}
